export default {"src":"/_next/static/media/negative-thoughts.mono.fdf40bf5.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};